import { Button as MUIButton } from "@mui/material";
import { useAppDispatch } from "app/hooks";
import { closeModal } from "app/reducers/modalSlice";
import classNames from "classnames";
import { useRef } from "react";
import { BUTTON_STYLES, BUTTON_TYPES } from "ui/Button";

import Label from "../../ui/Form/Label";
import { useOnClickOutside } from "../../utils/uiHooks";

type Props = {
  callback: () => void;
  callbackClose?: () => void;
  label: string;
  title?: string;
  closeButtonType: BUTTON_TYPES;
  confirmButtonType: BUTTON_TYPES;
  closeText: string;
  confirmText: string;
};

export const ConfirmationModal = ({
  label,
  title,
  closeButtonType,
  confirmButtonType,
  closeText,
  confirmText,
  callback,
  callbackClose,
}: Props) => {
  const dispatch = useAppDispatch();
  const ref = useRef(null);
  useOnClickOutside(ref, () => dispatch(closeModal()));

  const handleCloseButton = () => {
    if (callbackClose) return callbackClose();
    return dispatch(closeModal());
  };

  const handleConfirmButton = () => {
    callback();
    handleCloseButton();
  };

  return (
    <div className="w-full h-full bg-dark bg-opacity-70 fixed inset-0 z-10 overflow-y-auto">
      <div
        ref={ref}
        className="fixed top-2.5 right-2.22 flex justify-center items-center flex-col p-6 max-w-md bg-dark-gray-blue rounded-xl"
      >
        <div className="flex justify-center text-xl">
          <Label htmlFor={""} text={title || ""} />
        </div>
        <div className="flex justify-center pb-5 text-center">
          <Label htmlFor={""} text={label} />
        </div>
        <div className="flex align-end w-58 justify-between gap-5">
          <MUIButton
            variant="contained"
            onClick={handleCloseButton}
            className={classNames(BUTTON_STYLES[closeButtonType])}
          >
            {closeText}
          </MUIButton>
          <MUIButton
            variant="contained"
            onClick={handleConfirmButton}
            className={classNames(BUTTON_STYLES[confirmButtonType])}
          >
            {confirmText}
          </MUIButton>
        </div>
      </div>
    </div>
  );
};
